module.exports = __webpack_public_path__ + "static/media/1 2 tattoo back dragon fire warrior.1280x2276.7c9381a4.webp";